import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex);

let modules = {
};

//使用vuex-persist插件解决页面刷新后store为空的问题
const vuexLocal = new VuexPersistence({
    // storage: window.sessionStorage
    storage: window.localStorage
})
export default new Vuex.Store({
    state: {
      userInfo: null,
      token: null,
      association: null,
      preAnswers: null,
    },
    modules,
    actions,    // 根级别的 action
    mutations,  // 根级别的 mutations
    // 根级别的 getters
    getters: {
        userInfo: (state) => {
          const { userInfo } = state
          return JSON.parse(userInfo)
        },
        token: (state) => {
          const { token } = state
          return token
        },
        association: (state) => {
          const { association } = state
          return JSON.parse(association)
        },
        preAnswers: (state) => {
          const { preAnswers } = state
          return JSON.parse(preAnswers)
        },
    },
    plugins: [vuexLocal.plugin]
})
